import React from "react";
import { ShieldCheck, Scale, Sparkles, Globe, Lock, CircleCheck } from "lucide-react";
import { whyUs } from "../mock";

const iconMap = { ShieldCheck, Scale, Sparkles, Globe, Lock, CircleCheck };

export default function WhyUs() {
  return (
    <section id="about" className="section-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="max-w-3xl">
          <p className="eyebrow eyebrow-line">What sets us apart</p>
          <h2 className="font-serif-display mt-6 text-[2.1rem] md:text-[3rem] leading-[1.05] text-[#2a3325]">
            Independence, evidence, and a <span className="italic-accent">quiet</span> way of working.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border border-[#c4cfb2]">
          {whyUs.map((w, i) => {
            const Icon = iconMap[w.icon];
            const rightBorder = (i + 1) % 3 !== 0 ? "lg:border-r" : "";
            const bottomBorder = i < whyUs.length - 3 ? "lg:border-b" : "";
            const mdRight = i % 2 === 0 ? "md:border-r" : "";
            const mdBottom = i < whyUs.length - 2 ? "md:border-b" : "";
            return (
              <div
                key={w.title}
                className={`p-8 md:p-10 border-b border-[#c4cfb2] ${rightBorder} ${bottomBorder} ${mdRight} ${mdBottom} lg:border-[#c4cfb2] md:border-[#c4cfb2]`}
              >
                <Icon className="w-7 h-7 text-[#8a9a6b]" strokeWidth={1.3} />
                <h3 className="font-serif-display text-[1.4rem] leading-tight mt-6 text-[#2a3325]">{w.title}</h3>
                <p className="mt-3 text-[#4d5a45] leading-relaxed text-sm">{w.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
